import React from "react";
import { Card, CardGrid, Container, Header } from "./Elements";
import { motion } from 'framer-motion';

import image1 from './image/1.jpg'
import logo from './image/logo.jpg'

const color = {
  primary: '#333'
}
const App = () => {

  return (
    <>
      <Header style={{ background: color.primary }}>
        <img style={{ height: 50 }} src={logo} />
      </Header>
      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
          y: -70,
        }}
        transition={{
          duration: 1
        }}
      >
        <Container>
          <CardGrid>
            <Card >
              <img src={image1} alt='menu' />
            </Card>
          </CardGrid>
        </Container>
      </motion.div>
    </>
  );
}

export default App;
